import * as React from "react";
// import { styled } from "@mui/system";
import { styled } from "@vapor/react-material/styles";
import MUITab from "@mui/material/Tab";
import Stack from "@vapor/react-material/Stack";
import { TabProps as TabPropsMUI } from "@mui/material/Tab";
import {
  ExtendButtonBase,
  ExtendButtonBaseTypeMap
} from "@mui/material/ButtonBase";

import { tabFic } from "./tabFicStyling";
import { tabVapor } from "./tabVaporStyling";

export interface ExtendedTabProps extends TabPropsMUI {
  /**
   * If want to change variant of the component.
   * @default standard
   */
  variant?: "activeStep" | "standard";
  /**
   *If want to add an element to the right. Ex: Badge.
   */
  contentRight?: React.ReactElement;

  /**
   *If want to add an element to the left. Ex: Icon.
   */
  contentLeft?: React.ReactElement;
}

export const ExtendedTabRoot = styled(
  React.forwardRef<HTMLDivElement, ExtendedTabProps>(
    ({ contentLeft, contentRight, label, ...props }, ref) => {
      return (
        <MUITab
          ref={ref}
          {...props}
          label={
            <Stack direction="row" alignItems="center" spacing={1.25}>
              {contentLeft || null}
              <Stack>{label}</Stack>
              {contentRight || null}
            </Stack>
          }
        />
      );
    }
  ),
  {
    name: "ExtendedTab",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "variant",
    overridesResolver: (props, styles) => []
  }
)<ExtendedTabProps>(({ theme, variant }) =>
  theme?.name === "fic" ? tabFic(theme, variant) : tabVapor(theme, variant)
);

export type TabTypeMap<
  AdditionalProps = {},
  RootComponent extends React.ElementType = "div"
> = ExtendButtonBaseTypeMap<{
  props: AdditionalProps & ExtendedTabProps;
  defaultComponent: RootComponent;
}>;

export const ExtendedTab = React.forwardRef<HTMLDivElement, ExtendedTabProps>(
  function ExtendedTab(props, ref) {
    return <ExtendedTabRoot {...props} ref={ref} />;
  }
) as ExtendButtonBase<TabTypeMap<{}, "div">>;
